export default {
  heading: {
    fontFamily: 'heading',
    fontWeight: 'heavy',
    lineHeight: 'heading',
    margin: '1em 0',
    padding: 0
  },
  subheading: {
    fontFamily: 'heading',
    fontWeight: 'heavy',
    fontSize: 'subheading',
    lineHeight: 'subheading',
    margin: '1em 0',
    padding: 0
  },
  menu: {
    // medium.bold
    cursor: 'pointer',
    fontWeight: 700,
    fontSize: 'medium',
    lineHeight: 'medium'
  },
  breadcrumbs: {
    // medium regular
    fontFamily: 'body',
    letterSpacing: 'body',
    fontSize: 'medium',
    lineHeight: 'medium',
    fontWeight: 'regular',
    color: 'smoke.light',
    active: {
      fontFamily: 'body',
      letterSpacing: 'body',
      fontSize: 'medium',
      lineHeight: 'medium',
      fontWeight: 'regular',
      color: 'smoke.darker'
    },
    '&:hover': {
      color: 'smoke.darker'
    }
  },
  paragraph: {
    // medium.regular
    fontFamily: 'body',
    letterSpacing: 'body',
    fontSize: 'medium',
    lineHeight: 'medium',
    fontWeight: 'regular'
  },
  error: {
    // xSmall.regular
    fontFamily: 'body',
    letterSpacing: 'body',
    fontSize: 'xSmall',
    lineHeight: 'xSmall',
    fontWeight: 'regular',
    color: 'error',
    textTransform: 'lowercase',
    '&:first-letter': {
      textTransform: 'uppercase'
    }
  },
  form: {
    // display.small.bold
    fontFamily: 'heading',
    letterSpacing: 'heading',
    fontSize: 'display.small',
    lineHeight: 'display.small',
    fontWeight: 'display.bold',
    marginBottom: '1rem',

    description: {
      // medium.regular
      fontFamily: 'body',
      letterSpacing: 'body',
      fontSize: 'medium',
      lineHeight: 'medium',
      fontWeight: 'regular',
      color: 'smoke.light'
    }
  },
  table: {
    heading: {
      // display.xSmall.bold
      fontFamily: 'heading',
      letterSpacing: 'heading',
      fontSize: 'display.xSmall',
      lineHeight: 'display.xSmall',
      fontWeight: 'display.bold'
    }
  },
  settings: {
    heading: {
      // display.xSmall.bold
      fontFamily: 'heading',
      letterSpacing: 'heading',
      fontSize: 'display.xSmall',
      lineHeight: 'display.xSmall',
      fontWeight: 'display.bold',
      marginBottom: '0.5em'
    },
    description: {
      // medium.regular
      fontFamily: 'body',
      letterSpacing: 'body',
      fontSize: 'medium',
      lineHeight: 'medium',
      fontWeight: 'regular',
      color: 'smoke.light'
    }
  },
  huge: {
    bold: {
      fontFamily: 'body',
      letterSpacing: 'body',
      fontSize: 'huge',
      lineHeight: 'huge',
      fontWeight: 'bold'
    },
    regular: {
      fontFamily: 'body',
      letterSpacing: 'body',
      fontSize: 'huge',
      lineHeight: 'huge',
      fontWeight: 'regular'
    }
  },
  large: {
    bold: {
      fontFamily: 'body',
      letterSpacing: 'body',
      fontSize: 'large',
      lineHeight: 'large',
      fontWeight: 'bold'
    },
    regular: {
      fontFamily: 'body',
      letterSpacing: 'body',
      fontSize: 'large',
      lineHeight: 'large',
      fontWeight: 'regular'
    }
  },
  medium: {
    bold: {
      fontFamily: 'body',
      letterSpacing: 'body',
      fontSize: 'medium',
      lineHeight: 'medium',
      fontWeight: 'bold'
    },
    regular: {
      fontFamily: 'body',
      letterSpacing: 'body',
      fontSize: 'medium',
      lineHeight: 'medium',
      fontWeight: 'regular'
    }
  },
  small: {
    bold: {
      fontFamily: 'body',
      letterSpacing: 'body',
      fontSize: 'small',
      lineHeight: 'small',
      fontWeight: 'bold'
    },
    regular: {
      fontFamily: 'body',
      letterSpacing: 'body',
      fontSize: 'small',
      lineHeight: 'small',
      fontWeight: 'regular'
    }
  },
  xSmall: {
    bold: {
      fontFamily: 'body',
      letterSpacing: 'body',
      fontSize: 'xSmall',
      lineHeight: 'xSmall',
      fontWeight: 'bold'
    },
    regular: {
      fontFamily: 'body',
      letterSpacing: 'body',
      fontSize: 'xSmall',
      lineHeight: 'xSmall',
      fontWeight: 'regular'
    }
  },
  display: {
    huge: {
      bold: {
        fontFamily: 'heading',
        letterSpacing: 'heading',
        fontSize: 'display.huge',
        lineHeight: 'display.huge',
        fontWeight: 'display.bold',
        margin: '1em 0'
      },
      regular: {
        fontFamily: 'heading',
        letterSpacing: 'heading',
        fontSize: 'display.huge',
        lineHeight: 'display.huge',
        fontWeight: 'display.regular',
        margin: '1em 0'
      }
    },
    large: {
      bold: {
        fontFamily: 'heading',
        letterSpacing: 'heading',
        fontSize: 'display.large',
        lineHeight: 'display.large',
        fontWeight: 'display.bold',
        margin: '1em 0'
      },
      regular: {
        fontFamily: 'heading',
        letterSpacing: 'heading',
        fontSize: 'display.large',
        lineHeight: 'display.large',
        fontWeight: 'display.regular',
        margin: '1em 0'
      }
    },
    medium: {
      bold: {
        fontFamily: 'heading',
        letterSpacing: 'heading',
        fontSize: 'display.medium',
        lineHeight: 'display.medium',
        fontWeight: 'display.bold',
        margin: '1em 0'
      },
      regular: {
        fontFamily: 'heading',
        letterSpacing: 'heading',
        fontSize: 'display.medium',
        lineHeight: 'display.medium',
        fontWeight: 'display.regular',
        margin: '1em 0'
      }
    },
    small: {
      bold: {
        fontFamily: 'heading',
        letterSpacing: 'heading',
        fontSize: 'display.small',
        lineHeight: 'display.small',
        fontWeight: 'display.bold',
        margin: '1em 0'
      },
      regular: {
        fontFamily: 'heading',
        letterSpacing: 'heading',
        fontSize: 'display.small',
        lineHeight: 'display.small',
        fontWeight: 'display.regular',
        margin: '1em 0'
      }
    },
    xSmall: {
      bold: {
        fontFamily: 'heading',
        letterSpacing: 'heading',
        fontSize: 'display.xSmall',
        lineHeight: 'display.xSmall',
        fontWeight: 'display.bold',
        margin: '1em 0'
      },
      regular: {
        fontFamily: 'heading',
        letterSpacing: 'heading',
        fontSize: 'display.xSmall',
        lineHeight: 'display.xSmall',
        fontWeight: 'display.regular',
        margin: '1em 0'
      }
    }
  }
};
